import { styled } from '@linaria/react';

import { fonts, layout, semantic, space } from '../../theme/tokens';

export const PageWrapper = styled.section`
  width: 100%;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: ${space[4]} ${space[4]} ${space[8]};
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[7]} ${space[7]} ${space[10]};
  }
`;

export const PageGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[6]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    align-items: flex-start;
    gap: ${space[7]};
  }
`;

export const MainColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${space[6]};
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const OrderList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space[4]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

